import(/* webpackMode: "eager" */ "/vercel/path0/app/(feed)/for-you/page.tsx");
